import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/app/(app)/create-account/page.js");
